import { render, staticRenderFns } from "./IntegrationSettingsForm.vue?vue&type=template&id=00058af2"
import script from "./IntegrationSettingsForm.vue?vue&type=script&lang=js"
export * from "./IntegrationSettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports